import { createBrowserRouter, RouterProvider } from 'react-router'

import { sentryWrapCreateBrowserRouter } from '@libs/sentry/sentry'

import { routes } from './router.routes'

import type { JSX } from 'react'

const sentryCreateBrowserRouter = sentryWrapCreateBrowserRouter(createBrowserRouter)

const router = sentryCreateBrowserRouter(routes)

export const RouterContainer = (): JSX.Element => {
  return <RouterProvider router={router} />
}
